<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-15"
      >
        <div class="md-card md-theme-default">
          <div class="md-card-header">
            <h4 class="title">Filter</h4>
          </div>
          <div class="md-card-content">
            <div class="md-layout md-gutter md-size-100">
              <div class="md-layout-item md-size-100">
                <span>{{ $t("pipescanner_results.filter.d_from") }}</span>
                <md-datepicker v-model="dateStart" />
              </div>
              <div class="md-layout-item md-size-100">
                <span>{{ $t("pipescanner_results.filter.d_to") }}</span>
                <md-datepicker v-model="dateEnd" />
              </div>

              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>{{ $t("pipescanner_results.filter.material") }}</label>
                  <md-select
                    name="materials"
                    id="materials"
                    multiple
                    v-model="filter.materials"
                    @md-selected="filter_results"
                  >
                    <md-option value="AC">AC</md-option>
                    <md-option value="GGIJ">GGIJ</md-option>
                    <md-option value="PVC">PVC</md-option>
                    <md-option value="NGIJ">NGIJ</md-option>
                    <md-option value="STL">Steel</md-option>
                    <md-option value="HDPE">HDPE</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter md-size-100">
              <div class="md-layout-item md-size-100">
                <label>Diameter</label>
                <vue-slider
                  :min="0"
                  :max="1600"
                  :enable-cross="false"
                  v-model="filter.diameter"
                  @drag-end="filter_results"
                />
              </div>
            </div>
            <div
              class="md-layout md-gutter md-size-100"
              style="margin-top: 10px"
            >
              <div class="md-layout-item md-size-100">
                <label>{{
                  $t("pipescanner_results.filter.construction_year")
                }}</label>
                <vue-slider
                  :enable-cross="false"
                  :min="1800"
                  :max="2021"
                  v-model="filter.constructionyear"
                  @drag-end="filter_results"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-85"
      >
        <div class="md-card md-theme-default">
          <div class="md-card-header">
            <span class="custom-span">
              <h4 class="title">{{ $t("pipescanner_results.table.title") }}</h4>
            </span>
          </div>
          <div
            class="md-content md-table-content md-scrollbar md-theme-default"
            style="margin-top:0px; background-color: rgba(0,0,0,0.0); padding: 15px;"
          >
            <md-progress-spinner
              md-mode="indeterminate"
              v-if="resultsWidget.dataLoading"
            ></md-progress-spinner>
            <md-table
              @md-selected="onSelect"
              v-model="
                resultsWidget.data[groupSelected + '-pipescanner-inspections']
              "
              v-if="resultsWidget.data"
              md-sort="tag"
              md-sort-order="asc"
              style="width: 100%; margin-top:52px;"
            >
              <md-table-toolbar>
                <h1 class="md-title">
                  {{ $t("pipescanner_results.table.direction") }}
                </h1>
                <div class="md-toolbar-section-end"></div>
              </md-table-toolbar>
              <md-table-toolbar
                slot="md-table-alternate-header"
                slot-scope="{ count }"
                style="margin-top: 52px;"
              >
                <div class="md-toolbar-section-start">
                  {{ getAlternateLabel(count) }}
                </div>
                <div class="md-toolbar-section-end">
                  <md-progress-spinner
                    md-mode="indeterminate"
                    v-if="exporting.busy"
                  ></md-progress-spinner>
                  <md-button
                    class="md-button md-primary"
                    style="margin-left:2px"
                    v-if="selectedInspections.length == 1"
                    @click="edit(selectedInspections[0].id)"
                    >EDIT</md-button
                  >

                  <md-button
                    class="md-button md-primary"
                    style="margin-left:2px"
                    @click="redirect_details"
                    >Details</md-button
                  >
                  <md-button
                    class="md-button md-primary"
                    style="margin-left:2px"
                    @click="export_pipescanner_inspections"
                    >Export</md-button
                  >
                  <!--
                  <div v-if="groupSelected == 'acquaint.eu'">
                    <md-radio v-model="unitsSelected" value="metric"
                      >Metric</md-radio
                    >
                    <md-radio v-model="unitsSelected" value="imperial"
                      >Imperial</md-radio
                    >
                  </div> -->
                </div>
              </md-table-toolbar>

              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                md-selectable="multiple"
                md-auto-select
              >
                <md-table-cell md-label="ID" md-sort-by="tag">{{
                  item.tag
                }}</md-table-cell>
                <md-table-cell
                  :md-label="$t('pipescanner_results.table.header.date')"
                  md-sort-by="inspection_date"
                  >{{ item.inspection_date }}</md-table-cell
                >
                <md-table-cell
                  :md-label="
                    $t('pipescanner_results.table.header.construction_year')
                  "
                  md-sort-by="constructionyear"
                  md-numeric
                  >{{ item.constructionyear }}</md-table-cell
                >
                <md-table-cell md-label="Material" md-sort-by="material">{{
                  item.material
                }}</md-table-cell>
                <md-table-cell
                  md-label="Diameter"
                  md-sort-by="diameter"
                  md-numeric
                  >{{ convert(item.diameter).from(length1.save).to(length1.view).toFixed(3) }}</md-table-cell
                >
                <md-table-cell
                  :md-label="$t('pipescanner_results.table.header.exp_wt')"
                  md-sort-by="wallthickness_expected_validation"
                  >{{
                    convert(item.wallthickness_expected_validation).from(length1.save).to(length1.view).toFixed(2)
                  }}</md-table-cell
                >
                <md-table-cell
                  :md-label="$t('pipescanner_results.table.header.max_wt')"
                  md-sort-by="stats.max"
                  >{{ convert(item.stats.max).from(length1.save).to(length1.view).toFixed(2) }}</md-table-cell
                >
                <md-table-cell
                  :md-label="$t('pipescanner_results.table.header.min_wt')"
                  md-sort-by="stats.min"
                  >{{ convert(item.stats.min).from(length1.save).to(length1.view).toFixed(2) }}</md-table-cell
                >
                <md-table-cell
                  :md-label="$t('pipescanner_results.table.header.avg_wt')"
                  md-sort-by="stats.mean"
                  >{{ convert(item.stats.mean).from(length1.save).to(length1.view).toFixed(2) }}</md-table-cell
                >
                <md-table-cell
                  :md-label="$t('pipescanner_results.table.header.std_wt')"
                  md-sort-by="stats.std"
                  >{{ convert(item.stats.std).from(length1.save).to(length1.view).toFixed(2)}}</md-table-cell
                >
              </md-table-row>
            </md-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="css">
.md-table-alternate-header {
  margin-top: 0px;
}
</style>

<script>
import { mapState, mapMutations } from "vuex";
import JSZip from "jszip";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { MglMap, MglMarker, MglPopup } from "vue-mapbox";
//import xl from "excel4node";
import VueSlider from "vue-slider-component";
import { saveAs } from "file-saver";
import "vue-slider-component/theme/default.css";
import ExportXlsx from "@/exports/exports.js";
import convert from "convert-units";

export default {
  name: "PipescannerInspections",
  components: {
    VueSlider,
  },

  data: () => ({
    unitsSelected: "metric",
    dateStart: Date.parse("2020-01-01"),
    dateEnd: Number(new Date()) + 24*60*60*1000,
    //group stuff
    userGroups: [],
    permissions: [],

    //map variables
    viewMap: false,
    accessToken:
      "pk.eyJ1Ijoid2VybmVyYWNxIiwiYSI6ImNqeTc1d3VrajAxazUzb255NmM5cjhuMTYifQ.Z8ZqYDJDMAuGKKCHdehiSQ", // your access token. Needed if you using Mapbox maps
    mapStyle: "mapbox://styles/mapbox/streets-v11", // your map style
    centerCoordinates: [4.7760237, 51.5887845],

    //table variables
    plural: false,
    selected: [],
    inspections_results: [
      {
        id: "1234",
        tag: "test-inspection",
        inspection_date: "2020-12-21",
        constructionyear: 2020,
        material: "AC",
        diameter: 100,
        wallthickness_expected_validation: 14.08,
      },
    ],
    filter: {
      diameter: [0, 1200],
      materials: ["AC", "GGIJ", "PVC", "HDPE", "NGIJ", "STL"],
      inspection_date: ["2020-1-1", "2021-1-1"],
      constructionyear: [1800, 2021],
    },
    selectedInspections: [],
    //export variables
    showDialog: false,
    exportType: "excel",
    exportToggles: {
      pipeInfo: true,
      RDcoords: true,
      inspectionInfo: true,
      wtSerieMin: true,
      wtTotalStats: true,
    },

    //filter variables:
    materials: ["1", "2", "3", "4", "5"],
    query: "",
    ranges: {
      constructionyear: [0, 10000],
      diameter: [0, 10000],
      inspection_date: [0, 0],
    },
    rangesFound: false,
    resultsWidget: {
      dataLoading: false,
      data: null,
      unfilteredData: null,
      query_base:
        "SELECT c.id, c.tag, c.user, c.material, c.inspection_date, c.constructionyear, c.diameter, c.wallthickness_expected_validation, udf.inspection_stats(c.results) as stats FROM c WHERE IS_DEFINED(c.results)",
    },
    exporting: {
      busy: false,
    },
  }),
  watch: {
    /**
     * watcher to check change in materials
     * @param {Array} newMaterials - new array materials
     */
    materials_change: function(newMaterials) {
      console.log(newMaterials);
      //this.populate_results_widget();
    },
    dateStart: function(newVal) {
      this.filter_results();
    },
    dateEnd: function(newVal) {
      this.filter_results();
    },
    /**
     * watcher to check change in dates of date filter (on select is broken for md-datepicker)
     * @param {Array} newDates - New value filter dates
     */
    date_change: function(newDates) {
      this.filter_results();
    },
    /**
     * watcher to check the validity of route compared to services of group
     * @param {Array} newVal - New value of group services
     */
    groupServices(newVal) {
      if (!newVal.includes("pipescanner-inspections")) {
        this.$router.push("/");
      }
    },
  },
  computed: {
    ...mapState([
      "groupSelected",
      "apiEndpoints",
      "groupServices",
      "resultsData",
      "exportSettings",
      "units",
      "unitsDescription"
    ]),
    /**
     * computed property for unit conversion between mm and in
     * @return {obj} object with both view and save units
     */
    length1() {
      return {
        view: this.unitsDescription[this.units].length,
        save: this.unitsDescription.metric.length,
        metric: this.unitsDescription.metric.length,
        imperial: this.unitsDescription.imperial.length,
      };
    },
    /**
     * computed property for unit conversion between m and ft
     * @return {obj} object with both view and save units
     */
    length2() {
      return {
        view: this.unitsDescription[this.units].length2,
        save: this.unitsDescription.metric.length2,
        metric: this.unitsDescription.metric.length2,
        imperial: this.unitsDescription.imperial.length2,
      };
    },
    /**
     * Computed property to set query from filter options
     * @return {string} query, with filter options.
     */
    query_results_widget() {
      return (
        this.resultsWidget.query_base +
        " AND (" +
        "c.diameter BETWEEN " +
        this.filter.diameter[0] +
        " AND " +
        this.filter.diameter[1] +
        ")" +
        " AND c.material IN (" +
        this.filter.materials.map((x) => '"' + x + '"').join() +
        ") AND (c.constructionyear BETWEEN " +
        this.filter.constructionyear[0] +
        " AND " +
        this.filter.constructionyear[1] +
        ")"
      );
      /*AND (c.inspection_date >= '" +
        this.filter.inspection_date[0] +
        "' AND c.inspection_date <= '" +
        this.filter.inspection_date[1] +
        "') */
    },
    /**
     * Computed property to deep watch changes in material filter
     * @return {array} array containing materials
     */
    materials_change() {
      return this.filter.materials;
    },
    /**
     * Computed property to deep watch changes in date filter (depr.)
     * @return {array} array containing inspectiondate from and to
     */
    date_change() {
      return this.filter.inspection_date;
    },
  },
  mounted() {
    if (!this.resultsData) {
      this.populate_results_widget();
    } else {
      this.resultsWidget = this.resultsData;
    }
  },
  methods: {
    ...mapMutations([
      "SET_SELECTED_INSPECTIONS",
      "SET_SELECTED_EDIT",
      "SET_RESULTS_DATA",
    ]),
    convert: convert,
    /**
     * Redirect to editpage function. Sets the to-edit inspection
     * @param {string} id - id of inspection to edit
     */
    edit(id) {
      this.SET_SELECTED_EDIT(id);
      this.$router.push("/pipescanner-edit");
    },
    /**
     * function to construct label in plural or single when inspections selected
     * @param {int} count - amount of inspections selected.
     * @return {string} text label
     */
    getAlternateLabel(count) {
      let plural = "";

      if (count > 1) {
        plural = "s";
      }

      return `${count} inspectie${plural} geselecteerd`;
    },
    /**
     * function to filter inspections without querying
     */
    filter_results() {
      if (this.resultsWidget.data) {
        this.resultsWidget.data[
          this.groupSelected + "-pipescanner-inspections"
        ] = JSON.parse(
          JSON.stringify(
            this.resultsWidget.unfilteredData[
              this.groupSelected + "-pipescanner-inspections"
            ].filter((a) => {
              var inspDate = Date.parse(a.inspection_date);
              if (
                this.filter.materials.includes(a.material) &&
                a.constructionyear <= this.filter.constructionyear[1] &&
                a.constructionyear >= this.filter.constructionyear[0] &&
                a.diameter <= this.filter.diameter[1] &&
                a.diameter >= this.filter.diameter[0] &&
                inspDate <= this.dateEnd &&
                inspDate >= this.dateStart
              ) {
                return true;
              } else {
                return false;
              }
            })
          )
        );
      }
    },
    /**
     * function to populate results widget with inspections
     */
    async populate_results_widget() {
      this.resultsWidget.dataLoading = true;
      var query = {
        query: this.query_results_widget,
      };

      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;

      axios
        .post(endpoint, query, header)
        .then((response) => {
          this.resultsWidget.data = response.data;
          this.resultsWidget.unfilteredData = JSON.parse(
            JSON.stringify(response.data)
          );
          this.resultsWidget.dataLoading = false;
          this.SET_RESULTS_DATA(this.resultsWidget);
          //console.log(this.resultsWidget.unfilteredData);
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * function to set selected inspections
     * @param {Array} items - array of selected inspections.
     */
    onSelect(items) {
      this.selectedInspections = items; //.map(x => x.id);
    },
    /**
     * redirect function to inspection details
     */
    redirect_details() {
      this.SET_SELECTED_INSPECTIONS(this.selectedInspections);
      //console.log(this.selectedInspections);
      this.$router.push("/pipescanner-details");
    },
    /**
     * export function (xlsx)
     */
    async export_pipescanner_inspections() {
      this.exporting.busy = true;
      var query = {
        query:
          "SELECT * FROM c WHERE c.id IN (" +
          this.selectedInspections.map((x) => '"' + x.id + '"').join() +
          ")",
      };
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;
      var now = new Date();
      var settings = JSON.parse(JSON.stringify(this.exportSettings));
      settings["language"] = this.$i18n.locale.toLowerCase();
      axios
        .post(endpoint, query, header)
        .then((response) => {
          var inspectionData =
            response.data[this.groupSelected + "-pipescanner-inspections"];

          var exportObj = new ExportXlsx(
            inspectionData,
            0.1,
            15.0,
            settings,
            this.groupSelected,
            this.units
          );
          exportObj.generate_export_prom().then((export_wb) => {
            export_wb.writeToBuffer().then((buffer) => {
              var blob = new Blob([buffer], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              saveAs(blob, "Export-" + now.toISOString() + ".xlsx");
              this.exporting.busy = false;
            });
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
